import type { ReactNode } from 'react';

export interface IStackedInputsProps {
    children: ReactNode;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function StackedInputs(props: IStackedInputsProps) {
    return <div className="col has-stacked-inputs">{props.children}</div>;
}
